import { render, staticRenderFns } from "./work_items_saved_view_selector.vue.js?vue&type=template&id=9c485aba!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_items_saved_view_selector.vue?vue&type=template&id=9c485aba"
import script from "./work_items_saved_view_selector.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_items_saved_view_selector.vue?vue&type=script&lang=js"
export * from "./work_items_saved_view_selector.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_items_saved_view_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports